/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
/* eslint-disable react-hooks/exhaustive-deps */
'use client';

import { DeliveryType } from '@ahm/api-wrappers-core';
import { useLocationStore } from '@ahm/react-map/store';
import { Card, Collapse, Stack, Text } from '@mantine/core';
import { notifications } from '@mantine/notifications';
import { debounce } from 'lodash';
import { useCallback, useEffect, useState } from 'react';
import WarningDiamondIcon from '@/assets/icons/warning-diamond-red-icon.svg';

import { TOAST_TYPE, useToast } from '@/components/notifications';
import { useGetPackageSizeDefinitions } from '@/features/booking/api/master-data/use-get-package-size-definitions';
import { useServiceSuggestionMutation } from '@/features/booking/api/service/use-service-suggesstion-mutation';
import BikePackageHeader from '@/features/booking/components/bike-package-detail/components/bike-package-header';
import ItemDescriptionsSection from '@/features/booking/components/bike-package-detail/components/item-descriptions-section';
import SizeSection from '@/features/booking/components/bike-package-detail/components/size-section';
import WeightSection from '@/features/booking/components/bike-package-detail/components/weight-section';
import { useBookingService } from '@/features/booking/components/services/use-booking-service';
import { SERVICE_CONDITION_NOT_MET } from '@/lib/constants';
import useIsMobile from '@/lib/is-mobile/use-is-mobile';
import { useBookingStore } from '@/stores/booking/booking-store-provider';

export default function BookingPackageDetail() {
  const isMobile = useIsMobile();
  const [showBagaNotification, setShowBagaNotification] = useState(true);
  const [isWeightEdited, setIsWeightEdited] = useState(false);
  const { addToast, removeToast } = useToast();

  const {
    isOpenPopupAllService,
    createOrderError,
    bikePackageSize,
    bikePackageWeight,
    itemDescriptions,
    setBikePackageSize,
    setBikePackageWeight,
    setItemDescriptions,
    isSuggestionTruckServices,
    setIsSuggestionTruckServices,
    serviceId,
    setCreateOrderError,
    estimatedAllService,
    setIsEstimateAllService,
  } = useBookingStore((state) => state);

  const { data: sizeDefinitionList = [], isLoading } =
    useGetPackageSizeDefinitions();

  useEffect(() => {
    !showBagaNotification && setShowBagaNotification(true);
  }, [bikePackageSize, bikePackageWeight]);

  const { onOpenPopupAllService, onClosePopupAllService } = useBookingService({
    enabled: true,
  });
  const handleViewAllServices = () => {
    if (isOpenPopupAllService) {
      onClosePopupAllService();
      return;
    }

    onOpenPopupAllService();
    setIsEstimateAllService(true);
  };

  const { paths } = useLocationStore((state) => state);
  const [isOpen, setIsOpen] = useState(true);

  const [error, setError] = useState<string | null>(null);

  const handleSelect = (key: string, value: any) => {
    if (key === 'size') {
      const sizeItem = sizeDefinitionList.find((item) => item.size === value);
      if (sizeItem) {
        setBikePackageSize(sizeItem.size);
        if (!isWeightEdited && sizeItem?.default_weight_in_kilograms > 0) {
          setBikePackageWeight(sizeItem?.default_weight_in_kilograms);
        }
      }
    } else {
      setItemDescriptions(value);
    }
  };

  useEffect(() => {
    if (
      (bikePackageSize === '2XL' &&
        (!bikePackageWeight || bikePackageWeight < 80)) ||
      (!error &&
        bikePackageWeight &&
        bikePackageSize !== '3XL' &&
        bikePackageWeight > 60 &&
        bikePackageWeight < 80)
    ) {
      addToast({
        id: 'notification-baga',
        title: 'Đơn hàng của bạn sẽ được giao bằng xe có baga',
        autoClose: false,
        type: TOAST_TYPE.INFO,
      });
    } else {
      removeToast('notification-baga');
    }
  }, [bikePackageSize, bikePackageWeight, error]);

  const debounceInput = debounce((value: any) => {
    const weight = Number(value) || 0;
    if (weight > 2000 || weight <= 0) {
      const errorMessage =
        weight > 2000 ? 'Tối đa 2000kg' : 'Khối lượng không hợp lệ';
      setError(errorMessage);
      setBikePackageWeight(undefined);
      setCreateOrderError('package-detail');
      return;
    }

    setError(null);
    // if (itemDescriptions.length === 0) {
    //   setCreateOrderError('package-detail');
    // } else {
    //   setCreateOrderError(null);
    // }
    setBikePackageWeight(weight);
  }, 300);

  useEffect(() => {
    if (createOrderError && itemDescriptions.length && bikePackageWeight) {
      setCreateOrderError(null);
    }
  }, [bikePackageWeight, itemDescriptions, createOrderError]);

  const showAlertNotFoundService = useCallback(() => {
    if (
      estimatedAllService?.every(
        (item) => item.error?.code === SERVICE_CONDITION_NOT_MET
      )
    ) {
      notifications.clean();
      notifications.show({
        title: (
          <Text size="sm" fw={700} c="neutral.7">
            Không có dịch vụ phù hợp tại thời điểm này
          </Text>
        ),
        message: (
          <Text size="sm" fw={500} c="neutral.6">
            Bạn hãy điều chỉnh thông tin hàng hóa hoặc thử lại sau nhé
          </Text>
        ),
        autoClose: 5000,
        withCloseButton: false,
        style: {
          backgroundColor: 'var(--mantine-color-red-1)',
          color: 'var(--mantine-color-neutral-7)',
        },
        icon: <WarningDiamondIcon className="size-6" />,
      });
    }
  }, [estimatedAllService]);

  const { mutate: serviceSuggestionMutate } = useServiceSuggestionMutation({
    onSuccess: (data) => {
      if (!data) return;
      if (data.delivery_type === DeliveryType.Truck) {
        showAlertNotFoundService();
        removeToast('notification-baga');

        !isSuggestionTruckServices && setIsSuggestionTruckServices(true);
      }
      if (data.delivery_type === 'BIKE') {
        isSuggestionTruckServices && setIsSuggestionTruckServices(false);

        if (data.is_valid_service) {
          setIsEstimateAllService(false);
          // setCreateOrderError(null);
        } else {
          handleViewAllServices();
          !isMobile && window.scrollTo({ top: 0, behavior: 'smooth' });

          return;
        }
      }
    },
    onError: (error) => {
      console.log('error', error);
    },
  });

  const handleToggle = useCallback(() => {
    setIsOpen((prev) => !prev);
  }, []);

  useEffect(() => {
    const debouncedServiceSuggestion = debounce(() => {
      if (
        paths.length > 1 &&
        serviceId &&
        bikePackageSize &&
        bikePackageWeight
      ) {
        serviceSuggestionMutate({
          service_id: serviceId,
          path: paths,
          package_size: bikePackageSize,
          package_weight: bikePackageWeight,
        });
      }
    }, 300);

    debouncedServiceSuggestion();

    return () => {
      debouncedServiceSuggestion.cancel();
    };
  }, [bikePackageSize, bikePackageWeight, paths, serviceId]);

  useEffect(() => {
    if (createOrderError === 'package-detail') {
      const section = document.getElementById('bike-package-detail');
      if (section) {
        section.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [createOrderError]);

  return (
    <>
      <Card
        withBorder
        radius={12}
        p={0}
        // pr={16}
        mt={0}
        style={{
          borderColor:
            createOrderError === 'package-detail'
              ? 'var(--mantine-color-primary-6)'
              : 'white',
          background:
            !isOpen && createOrderError === 'package-detail'
              ? 'var(--mantine-color-red-0)'
              : 'white',
        }}
      >
        <BikePackageHeader isOpen={isOpen} onToggle={handleToggle} />

        <Collapse in={isOpen} p={0}>
          <Stack gap={0}>
            <SizeSection onChange={handleSelect} />
            <WeightSection
              error={error}
              onChange={debounceInput}
              onBlur={() => setIsWeightEdited(true)}
            />
            <ItemDescriptionsSection onChange={handleSelect} />
          </Stack>
        </Collapse>
      </Card>
    </>
  );
}
